export const updateCommentLikes = (
  comments: any,
  commentId: number,
  newLikes: any
) => {
  return comments.map((comment: any) => {
    if (comment.id === commentId) {
      // Обновляем количество лайков для этого комментария
      return { ...comment, ...newLikes };
    }

    if (comment.children) {
      // Рекурсивно обновляем количество лайков для всех ответов на этот комментарий
      const updatedReplies = updateCommentLikes(
        comment.children,
        commentId,
        newLikes
      );
      return { ...comment, children: updatedReplies };
    }

    return comment;
  });
};
